// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => (chunkId + ".js");